var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: {
        title: _vm.titleDialog,
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "600px",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onHandleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "contents" },
        [
          _c(
            "el-form",
            {
              ref: "refForm",
              attrs: {
                "label-width": "170px",
                model: _vm.formData,
                rules: _vm.formRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品命名规则", prop: "name" } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex a-center" },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          placeholder: "请输入",
                          clearable: "",
                          maxlength: "10",
                        },
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "ml10" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.formData.name,
                              },
                              on: { click: _vm.resetHandle },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择属性", prop: "field" } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择属性",
                            loading: _vm.loadingData,
                          },
                          model: {
                            value: _vm.formData.field,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "field", $$v)
                            },
                            expression: "formData.field",
                          },
                        },
                        _vm._l(_vm.dataList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.field_key,
                              value: item.field_key,
                              disabled: item.is_show != 1,
                            },
                          })
                        }),
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ml10" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.formData.field,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addHandle("custom")
                                },
                              },
                            },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "公共属性", prop: "field1" } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择公共属性",
                          },
                          model: {
                            value: _vm.formData.field1,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "field1", $$v)
                            },
                            expression: "formData.field1",
                          },
                        },
                        _vm._l(_vm.publicArr, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.name, value: item.key },
                          })
                        }),
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ml10" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.formData.field1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addHandle("public")
                                },
                              },
                            },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-form-item", { attrs: { label: "符号", prop: "prefix" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "请选择符号" },
                        model: {
                          value: _vm.formData.prefix,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "prefix", $$v)
                          },
                          expression: "formData.prefix",
                        },
                      },
                      _vm._l(_vm.PUBLIC_PROPERTY_ENUM, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ml10" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled:
                                !_vm.formData.name || !_vm.formData.prefix,
                            },
                            on: { click: _vm.addFuHao },
                          },
                          [_vm._v("添加")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onHandleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loadingSubmit },
              on: { click: _vm.onHandleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }